import React, { createContext, useMemo } from 'react';
import { useAppSelector } from 'hooks';
import { TranslationsType } from 'src/languages/language-types';
import { en } from 'src/languages/en';
import { ch } from 'src/languages/ch';

const translationsByLanguage: Record<string, TranslationsType> = {
  en,
  ch
};

export const TranslationContext = createContext<TranslationsType>(translationsByLanguage.en);

export const TranslationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // const { language } = useAppSelector(state => state.user.userSettings);
  const language = 'en';
  const TRANSLATION_TEXT = useMemo(() => translationsByLanguage.en, [language]);

  return (
    <TranslationContext.Provider value={TRANSLATION_TEXT}>{children}</TranslationContext.Provider>
  );
};
